<template>
   <div>
    <v-card> 
    <v-card-title>
    <h2>{{ ctitle }}</h2>
    <v-spacer></v-spacer>
    <v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
            <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.text }}</span>
            </v-chip>
            <span
              v-if="index === 1"
              class="grey--text caption"
            >(+{{ filteredheaders.length - 1 }} others)</span>
          </template>
            </v-select>
          <!-- </v-flex> -->
    
    <v-btn icon class="mx-0" @click="download">
      <v-icon title="Excel Download" color="green">save_alt</v-icon>
    </v-btn>
    
    <v-btn icon class="mx-0" @click="reset">
       <v-icon title="Reload" color="blue">refresh</v-icon>
    </v-btn>
    
    <v-text-field clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
   
	    <v-card-text>
                <div class="grid grid-cols-1 lg:grid-cols-1">
                    <label class="text-lg font-semibold">Filters:</label>
                    <v-select v-model="filterBlankNetids" :items="filterBlankNetidItems" outlined
                              label="Load Blank Netids?"></v-select>
                </div>
            </v-card-text>

    <v-divider></v-divider>
   
    <v-data-table  :footer-props="{'items-per-page-options': [50,100,500,1000,5000]}"  :headers="filteredheaders" :loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" show-group-by multi-sort>
    
    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
    
        <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
              <span> {{ header.text }} </span>
          <div v-if="headers_to_filter.includes(header.text)">
              <div v-if="filters.hasOwnProperty(header.value)">
                                    <v-autocomplete
                                        flat
                                        hide-details
                                        multiple
                                        attach
                                        chips
                                        full-width
                                        hide-no-data
                                        clearable
                                                     disable-lookup
                                        :items="columnValueList(header.value).sort()"
                                        v-model="filters[header.value]"
                                    >
                                                                  <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index < 5">
                                                 <span> 
                            {{ item }} 
                          </span>
                                            </v-chip>
                                            <span v-if="index === 5" class="grey--text caption" > 
                          (+{{ filters[header.value].length - 5 }} others) 
                          </span>
                                        </template>
                                    </v-autocomplete>
                                </div>
                                </div>
        </template>
   
    </v-data-table>
    
    </v-card>
      <v-snackbar v-model="snackbar" :timeout="5000" :color="snackcolor">
                {{ snacktext }}
                <v-btn color="white" text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    </template>
    
    <script>
    import XLSX from 'xlsx';
   
    export default {
            data() {
                    return { 
    app_name: process.env.MIX_APP_NAME,
    validationErrors: '',
    search: this.search_value,
    fill:[],
	 filterBlankNetids: true,
            filterBlankNetidItems: [
                {text: 'Yes', value: false},
                {text: 'No', value: true},
            ],
    headers_to_filter: ['Netid'],
    filteredheaderarray: [],
    headerarray:[],
    index: -1,
    progress_bar_loading: true,
                    snackbar: false,
                    snackcolor: '',
                    snacktext: '',
    dialog: false,
    dialog_add: false,
    dialog_update: false,
    loadingStore: false,
    loadingUpdate: false,
    defaultItem: {
                id: '',
                netid: '',
                
    },
    addedItem: {
                id: '',
                netid: '',
                
    },
    updateItem: {
                id: '',
                netid: '',
               
    },
    
    hide_headers:[],
    rowsPerPageItems: [10,50,100,2000],
    headers: [
    { text: 'Last Active', value: 'last_active', sortable: true, groupable: false, },
    { text: 'Netid', value: 'netid', sortable: true, groupable: true, filter: (value) => {
            if (!this.filterBlankNetids) 
	    	{
		    return true;
	    	}
            if (value != '') 
		{
		    return true;
		}
            return false;
           }},
    { text: 'Name', value: 'full_name', sortable: true, groupable: true, },
    { text: 'IP Address', value: 'ip_address', sortable: true, groupable: false, },
    { text: 'User Agent', value: 'user_agent', sortable: true, groupable: true, },
      ],
    
                    filters: {
    netid:[],
    full_name:[],
    ip_address:[],
    user_agent:[],
    last_active:[],
                    },
                    selected:[],
                    pagination: {
    
                    },
    
                    Results:[],
                    dialog: false,
    
            }
            },
                 created () {
                         this.initialize()
                 },
    watch: {
                dialog (val) {
                    val || this.close()
                },
            },
                   mounted() {
                           console.log('Indexall component mounted');
     },
    props: {
    ctitle: {
                 type: String,
                 required: true,
                                  },
      },
           computed:{
                    filteredResults() {
                    return this.Results.filter(d => {
                            return Object.keys(this.filters).every(f => {
                                    return this.filters[f].length < 1 || this.filters[f].includes(d[f])
                            })
                    })
                    },
            filteredheaders: { 
                get(){
                return this.headers.filter((h) => !this.hide_headers.includes(h.value)); 
                },
                set(newval){
                this.headers = newval;
                }
            },
            unfilteredheaders: { 
                get(){
                return this.headers.filter((h) => this.hide_headers.includes(h.value)); 
                },
                set(newval){
                this.headers = newval;
                }
            }
           },
    
    methods:
           {
                    columnValueList(val) {
                            //console.log(val)
                            return this.Results.map(d => d[val])
                    },
                   initialize()
                   {
                            this.fetchApp()
                            this.filteredheaders = this.headers;
                   },
    
             async fetchApp(){
                           await axios.get('/api/v1/appsessions')
                                   .then((response) => {
                                                   this.Results = (response.data);
                                                   this.progress_bar_loading = false;
                                                   })
                           .catch(error => {});
    
             },
    
              customFilter(items, search, filter) {
                        search = search.toString().toLowerCase();
                        this.fill = items.filter(i => (
                                                Object.keys(i).some(j => filter(i[j], search))
                                                ))
                                //console.log(this.fill);
                        return this.fill;
                },
            reset()
                         {
                         this.fetchApp();
                         },
                showForm: function (item) {
                    this.index = this.Results.indexOf(item);
                    this.updateItem = Object.assign({}, item);
                    this.dialog_update = true;
                },
    deleteItem: function(item) {
            confirm('Are you sure you want to delete this appsession?')
            axios.delete('/api/v1/appsessions/' + item.id)
                    .then(response => {
                if(response.status === 201 || response.status === 200) {
                        this.Results.splice(this.Results.indexOf(item), 1);
                this.snackbar = true;
                        this.snackcolor = 'success';
                        this.snacktext = 'The appsession was removed successfully.';
                        }
                         else
                                {
                                    this.snackbar = true;
                                    this.snackcolor = 'error';
                                    this.snacktext = 'An error occurred.  The appsession was not removed.';
                                }
                    })
    },
                close_add () {
                this.validationErrors = '';
                this.dialog_add = false
                this.addedItem = Object.assign({}, this.defaultItem);
            },
                close_update () {
                this.validationErrors = '';
                this.dialog_update = false
            },
            async store(item) {
                await axios.post('/api/v1/appsessions', item)
                    .then(response => {
                if(response.status === 201) {
                        this.Results.push(response.data);
                 this.snackbar = true;
                        this.snackcolor = 'success';
                        this.snacktext = 'Your appsession has been been saved.';
                        this.close_add()
                }
             else
                    {
                                    this.loadingStore = false;
                                    this.close_add();
                    this.snackbar = true;
                    this.snackcolor = 'error';
                    this.snacktext = 'Your appsession did NOT save.  Please logout and try again.';
                    }
                    })
         .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (error.response.status == 422) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Validation error.  See above.';
                                this.validationErrors = error.response.data.errors;
                            }
                else if (error.response.status == 401) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Unauthorized - Please close your browser and log in again.';
                                this.validationErrors = "Unauthorized - Please close your browser and log in again.";
                            } 
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
    
                        } else {
                            // Something happened in setting up the request that triggered an Error
    
                        }
                                this.loadingStore = false;
                    })
        },
        async update(item) {		
                        if (this.index > -1) {
                            this.loadingUpdate = true;
    
                            await axios.put('/api/v1/appsessions/' + item.id, item).then(response => {
                                if(response.status === 201 || response.status === 200) {
                                    Object.assign(this.Results[this.index], response.data)
                                    this.loadingUpdate = false;
                                    this.close_update();
    
                        this.snackbar = true;
                        this.snackcolor = 'success';
                        this.snacktext = 'Your appsession has been updated.';
    
                                }
                    else
                    {
                                    this.loadingUpdate = false;
                                    this.close_update();
                    this.snackbar = true;
                    this.snackcolor = 'error';
                    this.snacktext = 'Your appsession did NOT save.  Please logout and try again.';
                    }})
            .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (error.response.status == 422) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Validation error.  See above.';
                                this.validationErrors = error.response.data.errors;
                            }
                            else if (error.response.status == 401) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Unauthorized - Please close your browser and log in again.';
                                this.validationErrors = "Unauthorized - Please close your browser and log in again.";
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
    
                        } else {
                            // Something happened in setting up the request that triggered an Error
    
                        }
                                this.loadingUpdate = false;
                    });
                        } else {
                            console.log('updated data');
                            console.log(this.updateItem);
                        }
                    
                },
        download() {
          var first_record_json;
          var all_headers;
          var first_record_json;
          var first_record_json_keys;
          var all_headers_not;
    
          var local_delete = [];
    
          this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
    
          //ADDED because it was a computed value (template v-slot) that would not go in the download
          this.unfilteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
    
          this.headers.forEach(element => this.headerarray.push(element.value));
          first_record_json = this.Results[0];
    
          //console.log(first_record_json);
          first_record_json_keys  = Object.keys(first_record_json);
          all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
          // console.log(all_headers_not);
          // local_delete = this.fill;
          local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
          // console.log(this.filter_delete);
          for (var k =0;k<local_delete.length;k++)
          {
            for(var i=0;i<all_headers_not.length;i++)
            {
                    var key = all_headers_not[i];
                    delete local_delete[k][key];
            }
          }
          // console.log(this.filter_delete[0]);
          var work = XLSX.utils.json_to_sheet(local_delete);
          var new_workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                            var date = new Date();
          XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                            this.filteredheaderarray = [];
          this.headerarray = [];
        },
        BackgroundColor: function(tcourse, key) {
          var result = '';
          console.log('The key is ', key);
          if(key == 'approved')
                  {
                          if(tcourse.approved == 0)
                          {
                          result = 'badge p-2 h-3 font-weight-light badge-info'
                          }
                  else
              {
                result = 'badge p-2 font-weight-light badge-success'
              }
          }
    
          return result;
        },
    onEditorBlur(editor) {
          // console.log('editor blur!', editor)
        },
        onEditorFocus(editor) {
          // console.log('editor focus!', editor)
        },
        onEditorReady(editor, body = null) {},
        onEditorChange({ quill, html, text }) {
          // console.log('editor change!', quill, html, text)
          this.content = html;
        },
     }
    }
    </script>
    
